<template>
  <div class="restaurant-card">
    <!-- <div class="absolute z-10 top-1 right-2 text-2xs opacity-60 text-white" v-html="`${position}`" /> -->
    <div class="restaurant-card__media">
      <div class="restaurant-card__logo" v-if="restaurant.logo">
        <div class="restaurant-card__logo-size">
          <AtomImage class="h-full !object-contain object-left-bottom" :src="useCloudinaryImage(restaurant.logo, 200, null, 'fit,e_trim')" :alt="restaurant.name" />
        </div>
        <div class="restaurant-card__logo-fade"></div>
      </div>
      <AtomImage class="aspect-3/4" :src="useCloudinaryImage(restaurant.cover, 300, 400)" :alt="restaurant.name" />
    </div>
    <div class="restaurant-card__info">
      <div class="restaurant-card__heading">{{ restaurant.name }}</div>
      <div class="restaurant-card__meta">
        <AtomRestaurantLocation 
          :name="restaurant.address" 
          :address="restaurant.city"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  restaurant: {
    type: Object,
    default: () => {}
  },
  position: {
    type: Number,
    default: 0
  }
})
</script>

<style lang="scss" scoped>
.restaurant-card {
  @apply @container;
  @apply relative grid gap-2;

  &__media {
    @apply w-full bg-black relative rounded overflow-hidden;
  }

  &__logo {
    @apply absolute z-10 bottom-0 left-0 w-full p-3 grid gap-3;
  }

  &__logo-size {
    @apply relative z-10 w-24 h-12 invert;
  }

  &__logo-fade {
    @apply absolute bottom-0 left-0 w-full h-full bg-gradient-to-t from-25% from-black/80;
  }

  &__info {
    @apply grid gap-1;
  }
  
  &__heading {
    @apply font-heading font-medium text-lg @4xs:text-2xl @4xs:mt-2;
  }

  &__meta {
    @apply text-sm;
    // @apply text-sm @4xs:text-sm;
  }
}
</style>
